<script context="module">
  export function callAddItemClipboard (item) {
    if(addItm !== null) addItm(item)
  }
  let addItm = null
</script>

<script>
  import { Button, Input, Spinner, Container, Row, Col } from '@sveltestrap/sveltestrap'
  import { clipboardData, errorState, errorMessage, username, bearerToken } from './services/stores.js'
  import { createEventDispatcher } from 'svelte'
  import pastyClient from './lib/pastyclient.lib.js'
  import { notifier } from '@beyonk/svelte-notifications'
  import { _ } from 'svelte-i18n'


  let itemValue = ''
  const dispatch = createEventDispatcher()


  async function addItem(item) {
    if (item === null || item === undefined || item === '') {
      throw new Error($_('error.empty_item'))
    }

    try {
      const result = await pastyClient.addItem(item, $bearerToken)
      dispatch('item_added')
      notifier.success($_('notif.item_added'), { timeout: 5000 })
      return result
    } catch (err) {
      if (err.message === 'Invalid login credentials'){
        dispatch('login_failed', {
          failed: 'clipboardAdd',
          item: itemValue
        })
      } else {
        let message = err.message || $_('error.unknown')
        notifier.danger(err.message, { timeout: 5000 })
      }
    }
  }
  addItm = addItem


  const handleAddItem = (event) => {
    const button = event.currentTarget
    button.disabled = true
    addItem(itemValue).then(res => {
      button.disabled = false
    }).finally(() => {
      button.disabled = false
      itemValue = undefined
    })
  }

</script>

<Container>
  <Row class="align-items-right">
    <Input class="mb-2 mt-1" type="textarea" bind:value={itemValue} placeholder="{$_('add.placeholder')}"/>
  </Row>
  <Row class="align-items-right">
    <Button color="primary" on:click={handleAddItem}>
      {$_('add.button')}
    </Button>
  </Row>
</Container>
